<template>
    <form method="post" action="" v-on:submit="submitForm" enctype="multipart/form-data">
        <div class="form-group">
            <label>Brand: *</label><br />
            <select name="brand" v-model="brandId" required>
                <option v-for="brand of brands" :key="brand._id" :value="brand._id">{{ brand.name }}</option>
            </select>
        </div>
        <div class="form-group">
            <label>Software: *</label><br />
            <input type="radio" name="software" v-model="finalData.software" value="EXOCAD" required>&nbsp;EXOCAD <br/>
            <input type="radio" name="software" v-model="finalData.software" value="3SHAPE" required>&nbsp;3SHAPE
        </div>
        <div class="form-group">
            <label>Public/Private: *</label><br />
            <input type="radio" name="private" v-model="finalData.isPrivate" value="0" required>&nbsp;Public <br/>
            <input type="radio" name="private" v-model="finalData.isPrivate" value="1" required>&nbsp;Private
        </div>
        <div class="form-group">
            <label>Level: *</label><br />
            <input type="checkbox" name="level" v-model="finalData.level" value="IMPLANT">&nbsp;Implant Level <br/>
            <input type="checkbox" name="level" v-model="finalData.level" value="ABUTMENT">&nbsp;Abutment Level
        </div>
        <div class="form-group">
            <label>Library File (zip): *</label><br>
            <span class="existing-file" v-if="finalData.name">{{ finalData.name }}</span>
            <input type="file" v-on:change="fileSelected" name="library_file" :required="fileRequired" />
        </div>
        <div class="two-columns">
            <div class="form-group">
                <label>List of <u>skus</u> (one per line)</label>
                <textarea v-model="skusList"></textarea>
            </div>
            <div class="form-group">
                <label>List of <u>tags</u> (one per line)</label>
                <textarea v-model="tagsList"></textarea>
            </div>
        </div>
        <div class="form-group">
            <button type="submit">{{ submitText || 'Submit' }}</button>
        </div>
    </form>
</template>

<script>
export default {
    name: 'LibraryForm',
    props: ['formData', 'submitText'],
    emits: ['formSubmitted'],
    data: function() {
        return {
            finalData: this.formData ? JSON.parse(JSON.stringify(this.formData)) : { level: [] },
            brandId: null,
            selectedFile: null,
            fileRequired: this.formData ? false : true,

            skusList: this.formData?.skus?.join('\n'),
            tagsList: this.formData?.tags?.join('\n'),

            brands: []
        }
    },
    created() {
        this.axios.get(this.apiBase + '/brands')
              .then(response => {
                  this.brands = response.data.data
                  if (this.finalData.brand) {
                      this.brandId = this.finalData.brand._id
                  }
              })
              .catch(error => {
                  alert('Error occurred!')
                  console.log(error)
              })

        this.finalData.isPrivate = this.finalData.isPrivate ? "1" : "0"
    },
    methods: {
        fileSelected(e) {
            this.selectedFile = e.target.files[0]
        },
        submitForm(e) {
            e.preventDefault()
            const fd = new FormData()
            for (let k in this.finalData) {
                if (k === 'brand' || k === 'skus' || k === 'tags') {
                    continue
                }
                fd.append(k, this.finalData[k])
            }
            fd.append('brand', this.brandId)
            let skusToSend = this.skusList ? this.skusList.split('\n') : []
            fd.append('skus', skusToSend)
            let tagsToSend = this.tagsList ? this.tagsList?.split('\n') : []
            fd.append('tags', tagsToSend)
            if (this.selectedFile !== null) {
              fd.append('library_file', this.selectedFile)
            }
            this.$emit('formSubmitted', fd)
        }
    }
}
</script>

<style lang="scss" scoped>
.existing-file {
    display: block;
    width: fit-content;
    padding: 2px;
    margin-bottom: 2px;
    border: 1px solid #aaa;
}
.two-columns {
    display: flex;
    flex-flow: row;
    width: 100%;
    gap: 25px;
}
.two-columns > div {
    width: 100%;
}
</style>
